/**
 * Does a cached query result mention any of these attachment ids?
 *
 * The tracker uses this to refetch exactly the lists that are showing an
 * attachment the media service just finished processing (its URL moved from
 * the unrenderable original to the webp / mp4 rendition), without every
 * resource that can carry attachments having to be enumerated by name. Pure.
 */
export function queryHoldsAny(data: unknown, attachmentIds: string[]): boolean {
  if (data == null || attachmentIds.length === 0) return false;
  let serialized: string;
  try {
    serialized = JSON.stringify(data);
  } catch {
    return false;
  }
  if (!serialized) return false;
  return attachmentIds.some((id) => serialized.includes(`"${id}"`));
}
